import http from '../services/httpService';
import abpUserConfigurationService from '../services/abpUserConfigurationService';
import Utils from './utils';
import { normalizeRoleList } from './authUtils';

declare var abp: any;

export interface HostCurrentUser {
  id?: string;
  roles: string[];
}

/** Reload Zero-shaped grants after the B2C cookie is set so isGranted() matches the Host. */
export async function refreshAbpAuthFromHost(): Promise<void> {
  const data = await abpUserConfigurationService.getAll();
  const result = data?.data?.result;
  if (result) {
    Utils.extend(true, abp, result);
  }
}

export async function fetchHostCurrentUser(): Promise<HostCurrentUser> {
  const res = await http.get('/api/abp/application-configuration');
  const body = res.data?.currentUser ? res.data : res.data?.result;
  const currentUser = body?.currentUser || {};
  return {
    id: currentUser.id != null ? String(currentUser.id) : undefined,
    roles: normalizeRoleList(currentUser.roles),
  };
}
